<template>
  <div>
    <header-bar>
      スプリット
    </header-bar>
    <div class="page-block">
      <div class="page-block__inner">
        <div class="page-block__title title-font">
          スプリットへの招待をキャンセルしました。
        </div>
        <div class="subtitle">
          当リリースのスプリットが開始されることはありません。
        </div>
        <router-link
          :to="{name: 'index'}"
          class="c-btn">
          トップへ
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'

export default {
  name: 'RegistrationCompletion',
  components: {
    HeaderBar,
  },
}
</script>

<style scoped>
.page-block__inner {
  text-align: center;
  font-weight: 400;
}

.page-block{
  padding: 10px 30px;
  height: 73vh;
}

.title-font{
  font-size: 20px;
}
.subtitle {
margin-top: 15px;
  margin-bottom: 42px;
}
</style>
